import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var asideFooter = 'fx_2d2fb1e5_oxbbrj9';
var asideRoot = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_oxbbrj1',variantClassNames:{side:{left:'fx_2d2fb1e5_oxbbrj2',right:'fx_2d2fb1e5_oxbbrj3'}},defaultVariants:{},compoundVariants:[]});
var asideRootHeight = 'var(--fx_2d2fb1e5_oxbbrj0)';
var modalFog = 'fx_2d2fb1e5_oxbbrj8';
var scrollAreaChildrenRoot = 'fx_2d2fb1e5_oxbbrj5';
var scrollAreaRoot = 'fx_2d2fb1e5_oxbbrj4';
var scrollAreaViewPort = 'fx_2d2fb1e5_oxbbrj7';
var scrollAreaViewPortPaddingBottom = 'var(--fx_2d2fb1e5_oxbbrj6)';

export { asideFooter, asideRoot, asideRootHeight, modalFog, scrollAreaChildrenRoot, scrollAreaRoot, scrollAreaViewPort, scrollAreaViewPortPaddingBottom };
//# sourceMappingURL=aside.vanilla.mjs.map
